// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contactum-range-slider-wrap[data-v-42acb460]{display:flex;flex-direction:column;gap:6px}.contactum-range-output[data-v-42acb460]{font-size:14px;font-weight:600;color:#333}.contactum-range-slider[data-v-42acb460]{width:100%;cursor:default;accent-color:#0076ff}.contactum-range-labels[data-v-42acb460]{display:flex;justify-content:space-between;font-size:12px;color:#888}", ""]);
// Exports
module.exports = exports;
